module.exports = __webpack_public_path__ + "img/logo3.c7b1fbd3.png";